import { computed } from 'vue'
import { useStreamDonations } from '../StreamDonationOverview/useStreamDonations.js'

const MAX_VISIBLE_DONATIONS = 3

export default {
    name: 'StreamDonationOverviewHorizontal',
    props: {
        variation: {
            type: String,
            default: 'dark'
        },
        fundraisingId: {
            type: String,
            default: ''
        },
        footerText: {
            type: String,
            default: ''
        },
        minNyDonationSek: {
            type: Number,
            default: 2
        },
        maxNyDonationSek: {
            type: Number,
            default: 10
        },
        donationStyle: {
            type: String,
            default: 'normal'
        }
    },
    setup(props) {
        const {
            name,
            totalAmount,
            targetAmount,
            progressPercent,
            currentNew,
            previousDonations
        } = useStreamDonations(props)

        const chipVariation = computed(() =>
            props.variation === 'dark' ? 'light' : 'dark'
        )

        const visibleDonations = computed(() => {
            const chips = []
            if (currentNew.value) {
                chips.push({ ...currentNew.value, kind: 'new' })
            }
            for (
                let previousIndex = 0;
                previousIndex < previousDonations.value.length &&
                chips.length < MAX_VISIBLE_DONATIONS;
                previousIndex++
            ) {
                chips.push({
                    ...previousDonations.value[previousIndex],
                    kind: 'previous',
                    previousIndex
                })
            }
            return chips
        })

        return {
            name,
            totalAmount,
            targetAmount,
            progressPercent,
            footerText: props.footerText,
            donationStyle: props.donationStyle,
            chipVariation,
            visibleDonations
        }
    }
}
